var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { isLucidLinkConnectSupported } from '#features/lucidlink-connect';
import { useFilespaceById } from '#query-hooks';
export const FilespaceLucidLinkConnectRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const { query: { data: filespaceData }, } = useFilespaceById(workspaceId, filespaceId);
    if (!filespaceData) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Loading filespace data'), "data-testid": "filespace-data", isFullHeight: true }) }));
    }
    if (!isLucidLinkConnectSupported(filespaceData.format)) {
        return _jsx(Navigate, { to: "/workspaces" });
    }
    return children;
};
_react_refresh_temp_1 = FilespaceLucidLinkConnectRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "FilespaceLucidLinkConnectRouteGuard");
_react_refresh_temp_2(FilespaceLucidLinkConnectRouteGuard, "IkVkxd7Lrd+trlrW7MlBzmopsEs=", false, () => [useParams, useFilespaceById]);
